// extracted by mini-css-extract-plugin
module.exports = {"def":"paper_def__3xupZ"};